// JsFromRoutes CacheKey 939476b9206d8ecf5b4d9d8bfe598f44
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/users/:id/kiss'),
  frenchKissUser: /* #__PURE__ */ definePathHelper('post', '/users/:id/french_kiss'),
  newHotNote: /* #__PURE__ */ definePathHelper('get', '/users/:id/hot_note'),
}
